"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rewriteSchema = void 0;
const traverseSchema_1 = require("../traverseSchema/traverseSchema");
const isStandardJsonSchemaType_1 = require("../isStandardJsonSchemaType/isStandardJsonSchemaType");
const JsonSchemaType_1 = require("../../constants/JsonSchemaType");
const rewriteSchema = (rootSchema, options = {}) => {
    const { ignoreUndefinedRequiredFields = true } = options;
    const getCustomType = (type) => {
        if (type instanceof Array) {
            return type.find((item) => !(0, isStandardJsonSchemaType_1.isStandardJsonSchemaType)(item));
        }
        else if (typeof type === 'string' && !(0, isStandardJsonSchemaType_1.isStandardJsonSchemaType)(type)) {
            return type;
        }
    };
    return (0, traverseSchema_1.traverseSchema)(rootSchema, (schema) => {
        // Schema may contain required fields that are required but not present. Remove them.
        // https://squizgroup.atlassian.net/browse/FEAAS-497
        if (ignoreUndefinedRequiredFields) {
            if (schema.required) {
                schema.required = schema.required.filter((field) => schema.properties && field in schema.properties);
            }
        }
        // Ajv doesn't like non-standard types. "customType" is used to trigger our custom validation logic.
        // The "type" is then set to something standard to avoid Ajv throwing when attempting to validate.
        // https://github.com/ajv-validator/ajv/blob/27a88ea13c79becffc483db8f825343ac956bad0/lib/compile/validate/dataType.ts#L36
        // https://github.com/ajv-validator/ajv/issues/1875#issuecomment-1016820889
        // https://squizgroup.atlassian.net/browse/FEAAS-685
        const customType = getCustomType(schema.type);
        const nullable = schema.type instanceof Array && schema.type.includes(JsonSchemaType_1.StandardJsonSchemaType.Null);
        if (customType) {
            schema.customType = { customType, nullable };
            // Remove the schema type. Other types have undesired impacts:
            //  * object/array: the property is auto-initialise an empty object `{}` or array `[]`. if the field is
            //    required this empty value will pass the required validation.
            //  * null: no value can be provided, if the value is filled it will fail frontend validation.
            delete schema.type;
        }
    });
};
exports.rewriteSchema = rewriteSchema;
//# sourceMappingURL=rewriteSchema.js.map